/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createGroupOrder} from '../api'

export const useMutationCreateGroupOrder = createReactQueryMutationHook('createGroupOrder', createGroupOrder)
